export const providerManagerFilterOptions = [
  {
    label: "In-Network",
    key: "true",
  },
  {
    label: "Out of Network",
    key: "false",
  },
];

export const providerManagerFilterConfig = [
  {
    fieldName: "in_network",
    title: "Network Status",
    filterType: "SingleSelect",
    nameKey: "label",
    valueKey: "key",
    fetchFromAPI: false,
    staticData: providerManagerFilterOptions,
    options: providerManagerFilterOptions,
    permission: "",
  },
];
